    <form #formPrecio="ngForm"   novalidate="" (ngSubmit)="formSubmit(formPrecio)" > 
        <div class="row justify-content-center align-items-center " style=" margin-right: 0px; margin-left: 0px; ">
            <div class="col-lg-12 col-sm-12 col-md-12 col-12 " >
                <div style="align-items: center; justify-content: center; display: flex;">
                    <div class="form-group mt-3"  style="width: 250px;">
                        <label>Precio Actual</label>
                        <div class="input-group mt-2" >
                            <span class="input-group-text custom-input-group-text" ><i class="fas fa-dollar-sign"></i></span> 
                            <input type="number"   autocomplete="off"  step="0.2"  placeholder="Escribe el precio"
                                name="txtPrecio" #txtPrecio="ngModel" class="form-control  custom-input-group" 
                                pattern="^\d+(\.\d{1,2})?"   [(ngModel)]="formContent.precio" required>
                           
                        </div>        
                        <small class="mt-2"> Formato 0.00  </small>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2" style=" margin-right: 0px; margin-left: 0px; ">
            <div class="col text-end">
                <button type="button" (click)="onClose()" class="btn btn-sm rounded-button btn-secondary">
                            <i class="fa fa-arrow-left"></i>
                            Regresar
                </button>
                <button type="submit" [disabled]="!formPrecio.form.valid" class="side-space btn btn-sm rounded-button btn-success">
                    Aceptar
                    <i class="fa fa-check"></i>
                </button>
            </div>
        </div>
    </form> 
    <hr>
    <h6 class="blue"><i class="fas fa-file-lines"></i>&nbsp;Historial</h6>
    <div class="row mt-3" style=" margin-right: 0px; margin-left: 0px; ">
        <p-table #dt [value]="listaHistoria" [scrollable]="true" styleClass="p-datatable-sm" [scrollHeight]="'calc(100vh - 500px)'" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" 
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}" [rowsPerPageOptions]="[20,50,100,200]">
    
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="precio" class="medium-col" style="border-top-left-radius: 15px;"> Precio </th>
                    <th pSortableColumn="fechaCreacion" class="medium-col" style="border-top-right-radius: 15px;"> Fecha de creación </th>
                </tr>
    
                <tr class="filter-row">
                    <th>
                        <input placeholder="Filtrar"   type="text" #filtroPrecioAnterio class="form-input form-input-table-filter" (input)="dt.filter(filtroPrecioAnterio.value, 'precio', 'contains')">
                    </th>
    
                    <th class="filter-row">
                        <input placeholder="Filtrar" #filtroFechaCreacion type="text" class="form-input form-input-table-filter" (input)="dt.filter(filtroFechaCreacion.value, 'fechaCreacion', 'contains')">
                    </th>
                </tr>
            </ng-template>
    
            <ng-template pTemplate="body" class="animated fadeIn fast" let-precio>
                <tr>
                    <td class="medium-col"> {{ precio.precio | number: '1.2-2' }}  </td>
                    <td class="medium-col">  {{ precio.fechaCreacion | date: 'dd/MM/yyyy hh:mm aa' }} </td>
                </tr>
            </ng-template>
        </p-table>
    </div>